export const goal_list = [
  {
    Discipline: 'PT',
    GoalName: 'Activity tolerance 2 minute walk test LT',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved cardiopulmonary performance evidenced by a 2 minute walk test to (ENTER feet) feet with normal vital sign response in order to ambulate in community without fatigue and dyspnea',
  },
  {
    Discipline: 'PT',
    GoalName: 'Activity tolerance 6 min walk test LT',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved cardiopulmonary performance evidenced by a 6 minute walk test to (ENTER feet) feet with normal vital sign response in order to ambulate in community without fatigue and dyspnea.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Activity tolerance Cardiopulmonary performance LT',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved cardiopulmonary performance evidenced by ability to engage in exercise at an intensity of\n [RPE scale 6-20] utilizing [RPE/HRR] with normal vital sign response in order to engage in safe home exercise prescription for managing comorbidities and prevent adverse health outcomes.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Balance: BBTW LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate independence with use of Balance Wear Vest including don/doff and specific weight placements, wear schedule, cleaning, and verbalized understanding of when to consult physical therapist for adjustments',
  },
  {
    Discipline: 'PT',
    GoalName: 'Balance: BBTW perturbation score LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved static and dynamic balance evidenced by Balance Based Torso Weighting Perturbation score of in order to improve postural stability and reduce risk of falls.',
    TargetGoalText:
      'Client will demonstrate improved static and dynamic balance evidenced by Balance Based Torso Weighting Perturbation score of [Balance Based Torso Weighting Perturbation Score] in order to improve postural stability and reduce risk of falls.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Balance: Dynamic Gait Index LT',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved balance and gait stability evidenced by a Dynamic Gait Index score of\n\n [Dynamic Gait Index] in order to reduce fall risk and facilitate independent community ambulation.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Bed mobility-global LT',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates bed mobility performance evidenced by assistance needed as\n\n [Level of Assistance] .',
    TargetGoalText:
      'Client will demonstrate improved bed mobility evidenced by assistance needed as\n [Level of Assistance] in order to [Bed Mobility Life Participation OT] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Caregiver: General (LT) Goal',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Caregiver is able to assist patient to (ENTER FUNCTIONAL ACTIVITY) with [Level of Assistance] and [Verbal Cueing] .',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Bed mobility global STG',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'Caregiver will be able to assist patient to (ENTER FUNCTIONAL ACTIVITY) with [Level of Assistance] and [Verbal Cueing] to prepare for discharge to the next site of care.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Continence - ICIQ-UI LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates urinary leakage and impact on daily life evidenced by an ICIQ-UI score of [ICIQ-UI (2)] which [Impacts/Supports for CLOF goals] ability to [ICIQ- UI Life Participation] (ENTER specific info related to life participation).(ENTER additional specifics relate to life participation).',
    TargetGoalText:
      'Client will demonstrate decreased urinary leakage and reduced impact on daily life evidenced by an ICIQ-UI score of [ICIQ-UI (2)] in order to [ICIQ- UI Life Participation] (ENTER specific info related to life participation).(ENTER additional specifics relate to life participation).',
  },
  {
    Discipline: 'PT',
    GoalName: 'Continence - LTG Home exercise prescription/program',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates the ability to perform home exercise prescription evidenced by requiring [Assist level (basic)] verbal cues which [Impacts/Supports for CLOF goals] long term management of continence, quality of life, and participation in community activities.',
    TargetGoalText:
      'Client will demonstrate the ability to perform home exercise prescription evidenced by return demonstration requiring [Assist level (basic)] verbal cues in order to improve long term management of continence, quality of life, and participation in community activities.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Continence: PFIQ - 7 LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate reduced impact of bladder, bowel, vaginal symptoms evidenced by a Pelvic Floor Impact Questionnaire (PFIQ-7) score of (ENTER numerator) / (ENTER denominator)= (ENTER) % impact of bladder, bowel, and vaginal symptoms on daily quality life in order to improve ability to participate in household chores, exercise, travel, and frustration due to symptoms associated with the pelvic floor region. [Impacts/Supports for CLOF goals] ability to participate in household chores, exercise, travel, and frustration due to symptoms associated with the pelvic floor region.',
    TargetGoalText:
      'Client will demonstrate reduced impact of bladder, bowel, vaginal symptoms evidenced by a Pelvic Floor Impact Questionnaire (PFIQ-7) score of (ENTER numerator) / (ENTER denominator)= (ENTER) % impact of bladder, bowel, and vaginal symptoms on daily quality life in order to improve ability to participate in household chores, exercise, travel, and frustration due to symptoms associated with the pelvic floor region.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Dizziness Handicap Inventory LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client demonstrates perceived impact of dizziness symptoms on quality of life evidenced by a score on the Dizziness Handicap Inventory of [Dizziness Handicap Inventory] in order to improve quality of life and reduce risk of falls/further disability.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Edema (LT) Goal',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The patient presents with (ENTER BODY AREA) edema of [Increments 1] centimeters.',
    TargetGoalText:
      'The patient will decrease edema of (ENTER AREA) by [Increments 1] centimeters to improve skin integrity and increase ease with (ENTER FUNCTIONAL ACTIVITY).',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk (Fear of Falling): Activities Specific Balance Confidence Scale LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate reduced fear of falling and reduced fall risk evidenced by an Activities Based Confidence Scale score of\n [Activities-Specific Balance Confidence Scale] in order to engage in community mobility, ADLs, and IADLs with reduced fear and reduced risk of falls',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk : Berg Balance Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved balance and fall risk evidenced by a Berg Balance Scale score of\n [Berg Balance Scale with Fall risk] in order to safely engage in community mobility, ADLS, IADLs with reduced fall risk.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall risk : gait speed LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved gait stability and reduced fall risk evidenced by a self selected gait speed score of\n [Gait Speed Increments with signficance] in order to engage in community mobility, ADLS, and IADLs with reduced fall risk',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk: 4 Square Step Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved dynamic multi-directional balance evidenced by a Four Square Step Test Score of\n [Four Square Step Test (dynamic multi-directional balance)] in order to engage in safe community mobility, ADLS, and IADLS, with reduced risk of fall.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk: 5 times Sit to Stand LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates LE strength and balance levels evidenced by a Five Times Sit to Stand test score of [5 Times Sit to Stand] which affect ability to transfer and community mobility without risk of falls',
    TargetGoalText:
      'Client will demonstrate improved LE strength and balance evidenced by a Five Times Sit to Stand Test score of [5 Times Sit to Stand] in order to facilitate safe transfers and community mobility with reduced risk of falls',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall risk: Functional Gait Assessment LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved gait stability and reduced fall risk evidenced by a Functional Gait Assessment score of\n [Functional Gait Index with fall risk] in order to improve community mobility with reduced risk of falls.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk: Functional Reach Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates balance performance level and fall risk evidenced by a Functional Reach Test Score of\n [Functional Reach with Fall Rsik] which impacts ability to safely engage in community mobility, ADLs, and IADLS.',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk: Mini Balance Evaluation Systems Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved balance evidences by Mini Balance Evaluation Systems test score of\n [Mini Balance Evaluation Systems Test] in order to reduce risk of falls during community mobility.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall Risk: Single Leg Stand Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved balance and reduced fall risk evidenced by a Single Leg Stand test score of\n [Single Leg Stand Test] in order to engage in community mobility/ADLs/IADLs with reduced risk of falls.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Fall risk: Timed Up and Go LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved gait stability and reduced fall risk evidenced by a Timed Up and Go score of\n [TUG-Timed Up and Go with fall risk] in order to improve community mobility, ADLS, and IADLs with reduced fall risk.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Floor transfer (Floor Transfer Test) LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved floor to/from stand transfers evidenced by a Floor Transfer Test score of [Floor Transfer (Floor Transfer Test)] in order to safely and efficiently rise from the floor in the event of a fall, engage in ADLS and IADLS on the floor/ground, reduce risk of frailty, reduce loss of functional dependence, and reduce risk of death.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Floor Transfer: Sitting to Rising Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved floor to/from stand transfers evidenced by a Sitting-Rising Test score of\n [Floor Transfer: Sitting To Rising Test] safely and efficiently rise from the floor in the event of a fall, engage in ADLS and IADLS on the floor/ground, reduce risk of frailty, reduce loss of functional dependence, and reduce risk of death.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Frailty/Disability Risk: 5 times sit to stand LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates LE strength/power and balance performance level evidenced by a 5 times sit to stand score of in order to reduce risk of frailty, disability, hospitalization, and mortality',
    TargetGoalText:
      'Client demonstrates LE strength/power and balance performance level evidenced by a 5 times sit to stand score of [5 Times Sit to Stand] in order to reduce risk of frailty, disability, hospitalization, and mortality',
  },
  {
    Discipline: 'PT',
    GoalName: 'Frailty/Disability Risk: gait speed LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate reduced risk of frailty, disability, hospitalization, and mortality evidenced by a self selected gait speed of in order to reduce risk of future frailty, disability, hospitalization, and mortality',
    TargetGoalText:
      'Client will demonstrate reduced risk of frailty, disability, hospitalization, and mortality evidenced by a self selected gait speed of [Gait Speed Increments with signficance] in order to reduce risk of future frailty, disability, hospitalization, and mortality',
  },
  {
    Discipline: 'PT',
    GoalName: 'Frailty/Disability Risk: Modified Physical Performance Test LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate reduced risk of frailty, disability, hospitalization, and mortality evidenced by a Modified Physical Performance Test score of in order to reduce likelihood of future loss of independence and future adverse health outcomes.',
    TargetGoalText:
      'Client will demonstrate reduced risk of frailty, disability, hospitalization, and mortality evidenced by a Modified Physical Performance Test score of [Modified Physical Performance Test ] in order to reduce likelihood of future loss of independence and future adverse health outcomes.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Frailty/Disability Risk: Physical Performance Test 7 item LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'PPT 9 STG\nClient will demonstrate improved physical function/frailty level evidenced by a Physical Performance Test 7 item score of in order to reduce likelihood of loss of independence and reduce risk of adverse health outcomes associated with frailty.',
    TargetGoalText:
      'PPT 9 STG\nClient will demonstrate improved physical function/frailty level evidenced by a Physical Performance Test 7 item score of [Physical Performance Test 7 item] in order to reduce likelihood of loss of independence and reduce risk of adverse health outcomes associated with frailty.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Frailty/Disability Risk: Physical Performance Test 9 item LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved physical function/frailty level evidenced by a Physical Performance Test 9 item score of in order to reduce likelihood of loss of independence and reduce risk of adverse health outcomes associated with frailty.',
    TargetGoalText:
      'The patient will safely complete [Laundry] utilizing [ADL device] increasing to [Level of Assistance] [Initiation Cue] [Percent] [Verbal Cueing] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Frailty/Disability Risk: Short Physical Performance Battery LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client will demonstrate reduced risk of mobility disability, all-cause mortality, and risk of ADL disability evidenced by a Short Physical Performance Battery score of in order to reduce risk of future adverse health outcomes.',
    TargetGoalText:
      'The client will demonstrate reduced risk of mobility disability, all-cause mortality, and risk of ADL disability evidenced by a Short Physical Performance Battery score of [Short Physical Performance Battery (SPPB)] in order to reduce risk of future adverse health outcomes.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Gait level surfaces LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved gait stability and safety evidenced by ability to ambulate on level surfaces for with and in order to .',
    TargetGoalText:
      'Client will demonstrate improved gait stability and safety evidenced by ability to ambulate on level surfaces for [Distance Feet] with [Gait assistive device] and [Level of Assistance] in order to [Gait life participation scale for PT] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Gait uneven surfaces LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved gait stability and safety evidenced by ability to ambulate on uneven surfaces for with and in order to .',
    TargetGoalText:
      'Client will demonstrate improved gait stability and safety evidenced by ability to ambulate on uneven surfaces for [Distance Feet] with [Gait assistive device] and [Level of Assistance] in order to [Gait life participation scale for PT] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Gait: advanced dynamic (FGA) LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved dynamic gait stability and safety evidenced by a Functional Gait Assessment score of in order to .',
    TargetGoalText:
      'Client will demonstrate improved dynamic gait stability and safety evidenced by a Functional Gait Assessment score of [Functional Gait Index with fall risk] in order to [Gait life participation scale for PT] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Gait: Curbs & Ramps - LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Curb ramp] [Gait assistive device] [Level of Assistance] [Impacts/Supports for CLOF goals]',
    TargetGoalText:
      'The client will demonstrate improved ability to safely ascend/descend [Curb ramp] with [Gait assistive device] and [Level of Assistance] in order to engage in community mobility.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Gait: gait speed LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved gait stability and safety evidenced by a self selected gait speed of in order to .',
    TargetGoalText:
      'Client will demonstrate improved gait stability and safety evidenced by a self selected gait speed of [Gait Speed Increments with signficance] in order to [Gait life participation scale for PT] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Gait: stairs LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved gait stability and safety on stairs evidenced by ability to ambulate up/down stairs with and in order to .',
    TargetGoalText:
      'Client will demonstrate improved gait stability and safety on stairs evidenced by ability to ambulate up/down [Stairs 1-12] stairs with [Stairs assistive device] and [Level of Assistance] in order to [stairs life participation scale] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Home Exercise Program (LT) Goal',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Patient is able to complete home exercise program for (ENTER PURPOSE OF PROGRAM) with [Level of Assistance] and [Verbal Cueing] .',
    TargetGoalText:
      'Patient will be able to complete home exercise program for (ENTER PURPOSE OF PROGRAM) with [Level of Assistance] and [Verbal Cueing] to (ENTER FUNCTIONAL TASK).',
  },
  {
    Discipline: 'PT',
    GoalName: 'Incontinence',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The patient has reduced episodes of urinary incontinence to [Increments 1] per day.',
    TargetGoalText:
      'The patient will have a reduction in episodes of urinary incontinence to [Increments 1] per day to increase safety and reduce risk of (ENTER RISK).',
  },
  {
    Discipline: 'PT',
    GoalName: 'Incontinence - Caregiver',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The Patient/Caregiver (ENTER IS OR IS NOT) independent in an incontinence management program to maintain incontinence reduction achieved upon discharge.',
    TargetGoalText:
      'The Patient/Caregiver will be independent in an incontinence management program to maintain incontinence reduction achieved upon discharge.',
  },
  {
    Discipline: 'PT',
    GoalName: 'LTG custom - 1',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved (ENTER underlying impairment or functional deficit) evidenced by (ENTER measure) in order to (ENTER life participation).',
  },
  {
    Discipline: 'PT',
    GoalName: 'LTG custom - 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved (ENTER underlying impairment or functional deficit) evidenced by (ENTER measure) in order to (ENTER life participation).',
  },
  {
    Discipline: 'PT',
    GoalName: 'LTG custom - 3',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved (ENTER underlying impairment or functional deficit) evidenced by (ENTER measure) in order to (ENTER life participation).',
  },
  {
    Discipline: 'PT',
    GoalName: 'LTG custom - 4',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will safely walk a distance of [Feet] , [Home Health Assistance] with [Assistive Device] in order to [Home Health - in order to] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'LTG-5',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Pain 0-10 scale LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate reduced pain in (ENTER pain location) evidenced by a self-reported pain scale rating of\n [pain scale 0-10] in order to [Pain Life participation 2] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Pain: Pain Self Efficacy Quotient LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will increase [Extremities] [Elbow Movement] muscle strength [Muscle Strength] in order to [UE Targets] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Skin Integrity',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: 'The patient exhibits loss of skin integrity of [Extremities] .',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Prosthetic/Orthotic Use',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will safely ambulate up/down [Increments 1] of steps (ENTER WITH OR WITHOUT) rail with [Level of Assistance] and [Assistive Device] to enter/exit home.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Stairs - Home',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client safely ambulates up/down [Increments 1] of steps (ENTER WITH OR WITHOUT) rail with [Assistive Device] .',
    TargetGoalText:
      'The client will safely ascend/descend [Increments 1] of steps (ENTER WITH OR WITHOUT) rail with [Stair Climbing Scale] in order to return home.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Stairs: Entry/Exit Home (LT) Goal',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The patient ambulates up/down [Increments 1] of steps (ENTER WITH OR WITHOUT) rail with [Level of Assistance] and [Assistive Device] to enter/exit home.',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Stairs: Entry/Exit Home (ST) Goal',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will safely ambulate up/down [Increments 1] of steps (ENTER WITH OR WITHOUT) rail with [Level of Assistance] and [Assistive Device] to enter/exit home.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Strength:General',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will increase muscle strength to [Muscle Strength] of [Extremities] (ENTER JOINT AND MOVEMENT) in order to [Ambulation Goal] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'THRIVE : Energy',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate independence with progressive cardiopulmonary home exercise prescription based on recommended exercise intensity , frequency, duration, and mode for his/her comorbidities and precautions in order to reduce risk of functional disability',
  },
  {
    Discipline: 'PT',
    GoalName: 'THRIVE: all',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate independence with comprehensive and progressive cardiopulmonary, flexibility, strength, and balance home exercise prescription based on recommended exercise intensity , frequency, duration, and mode for his/her comorbidities and precautions in order to reduce risk of functional disability',
  },
  {
    Discipline: 'PT',
    GoalName: 'THRIVE: Balance',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate independence with progressive balance home exercise prescription based on recommended exercise intensity , frequency, duration, and mode for his/her comorbidities and precautions in order to reduce risk of functional disability',
  },
  {
    Discipline: 'PT',
    GoalName: 'THRIVE: Flexibility',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate independence with progressive flexibility home exercise prescription based on recommended exercise intensity , frequency, duration, and mode for his/her comorbidities and precautions in order to reduce risk of functional disability',
  },
  {
    Discipline: 'PT',
    GoalName: 'THRIVE: strength /resistance',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate independence with progressive strength/resistance home exercise prescription based on recommended exercise intensity , frequency, duration, and mode for his/her comorbidities and precautions in order to reduce risk of functional disability',
  },
  {
    Discipline: 'PT',
    GoalName: 'Transfers PT LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved [Transfer type] transfers evidenced by assistance needed of [Level of Assistance] with [Assistive Device] in order to [PT transfer participation ] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'WheelChair - sitting tolerance LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently demonstrates abnormal posture of [Postural Deviations] while sitting in [chairs 1] with a sitting tolerance less than or equal to [Increments] hours.',
    TargetGoalText:
      'Client will demonstrate supported sitting tolerance for [Increments] hours in [chairs 1] with pressure relieving cushion as evidenced by no overt [Postural Deviations] , skin compromise or abnormal vital sign response in order to participate in their environment at a wheelchair level.',
  },
  {
    Discipline: 'PT',
    GoalName: 'WheelChair - sitting tolerance1',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently demonstrates abnormal posture of [Postural Deviations] while sitting in [chairs 1] with a sitting tolerance less than or equal to [Increments] hours.',
    TargetGoalText:
      'Client will demonstrate supported sitting tolerance for [Increments] hours in [chairs 1] with pressure relieving cushion as evidenced by no overt [Postural Deviations] , skin compromise or abnormal vital sign response in order to participate in their environment at a wheelchair level.',
  },
  {
    Discipline: 'PT',
    GoalName: 'WheelChair - sitting tolerance2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently demonstrates abnormal posture of [Postural Deviations] while sitting in [chairs 1] with a sitting tolerance less than or equal to [Increments] hours.',
    TargetGoalText:
      'Client will demonstrate supported sitting tolerance for [Increments] hours in [chairs 1] with pressure relieving cushion as evidenced by no overt [Postural Deviations] , skin compromise or abnormal vital sign response in order to participate in their environment at a wheelchair level.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PIDA Global LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage powered mobility device as evidenced by (ENTER score)% score on PIDA in order to increase their ability to safely navigate in their apt./cottage room, complete ADL routine, and retrieve personal items.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage powered mobility device as evidenced by (ENTER score)% score on PIDA in order to increase their ability to safely navigate in their apt./cottage room, complete ADL routine, and retrieve personal items.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PIDA Subtest LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will improve the ability to manage electric mobility device as evidenced by a (ENTER score)/4 on PIDA subtest in order to safely navigate in their room, complete ADL routine, and retrieve personal items.',
    TargetGoalText:
      'Client will improve the ability to manage electric mobility device as evidenced by a (ENTER score)/4 on PIDA [PIDA subtest] subtest in order to safely navigate in their room, complete ADL routine, and retrieve personal items.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PIDA Subtest LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will improve the ability to manage electric mobility device as evidenced by a (ENTER score)/4 on PIDA subtest in order to safely navigate in their room, complete ADL routine, and retrieve personal items.',
    TargetGoalText:
      'Client will improve the ability to manage electric mobility device as evidenced by a (ENTER score)/4 on PIDA [PIDA subtest] subtest in order to safely navigate in their room, complete ADL routine, and retrieve personal items.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PoMoDATT Global LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidenced by score of (ENTER score)/104 on PoMoDATT in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidenced by score of (ENTER score)/104 on PoMoDATT in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PoMoDATT Subtest 2 LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT [PoMoDATT Subtest] subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PoMoDATT Subtest 3 LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT [PoMoDATT Subtest] subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PoMoDATT Subtest 4 LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT [PoMoDATT Subtest] subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Assessment: PoMoDATT Subtest LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage electric mobility device as evidence by a score of (ENTER score)/4 on PoMoDATT [PoMoDATT Subtest] subtest, in order to safely attend community events, navigate in their cottage/apt, retrieve mail, and attend outings/medical appointments.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Component Management LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client is currently demonstrating ability to manage [Wheelchair components] with [Caregiver cueing] which negatively impacts their ability to safely participate in the environment.',
    TargetGoalText:
      'Client will demonstrate improved management of [Wheelchair components] as evidenced by decreased need of verbal cues to [Caregiver cueing] in order to safely participate in the environment at a wheelchair level.',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Mobility: Distance (ST) Goal',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate appropriate navigation of environmental obstacles with a [Power chairs] at a assistance level of [Assistance Level] with [Caregiver cueing] in order to safely operate power vehicle to [Functional Distances for Discharge] .',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Obstacle Navigation - manual w/c',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently requires [Caregiver cueing] and [Assistance Level] level of assistance, in order to safely navigate environmental obstacles using their [Extremities] .',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair Obstacle Navigation - Power wheelchair (ltg)',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently requires [Caregiver cueing] and [Assistance Level] level of assistance, in order to safely operate power vehicle around environmental obstacles.',
    TargetGoalText: '',
  },
  {
    Discipline: 'PT',
    GoalName: 'Wheelchair propulsion LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently is [Able/Unable] to self propel wheelchair with [Assistance Level] level of assistance, utilizing their [Extremities] in a [chairs 1] .',
    TargetGoalText:
      'The client will demonstrate improved wheelchair propulsion using their [Extremities] in a [chairs 1] at an assistance level of [Assistance Level] over a distance of [Feet] in order to navigate [Functional Distances for Discharge] .',
  },
  {
    Discipline: '',
    GoalName: 'Wound-General',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The patient demonstrates healing of (ENTER LOCATION) wound to [Wound Stage] .',
    TargetGoalText: '',
  },
  {
    Discipline: '',
    GoalName: 'Wheelchair propulsion STG',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will demonstrate healing of (ENTER LOCATION) wound to [Wound Stage] in order to allow for improved skin integrity and reduce risk of (ENTER RISK).',
  },
  {
    Discipline: 'OT',
    GoalName: 'ADL Transfers LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] for transfers [ADL Transfers Type] with [ENTER AD/DME: ie: no device, Grab bars, Shower chair, Tub Transfer bench, Toilet rails, Bed side commode] which [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [ADL Transfers Type] as evidenced by assistance needed of [Assistance Level] with [ENTER AD/DME: ie: no device, Grab bars, Shower chair, Tub Transfer bench, Toilet rails, Bed side commode] in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'ADL Transfers LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] for transfers [ADL Transfers Type] with [ENTER AD/DME: ie: no device, Grab bars, Shower chair, Tub Transfer bench, Toilet rails, Bed side commode] which [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [ADL Transfers Type] as evidenced by assistance needed of [Assistance Level] with [ENTER AD/DME: ie: no device, Grab bars, Shower chair, Tub Transfer bench, Toilet rails, Bed side commode] in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'ADL Transfers LTG 3',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] for transfers [ADL Transfers Type] with [ENTER AD/DME: ie: no device, Grab bars, Shower chair, Tub Transfer bench, Toilet rails, Bed side commode] which [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [ADL Transfers Type] as evidenced by assistance needed of [Assistance Level] with [ENTER AD/DME: ie: no device, Grab bars, Shower chair, Tub Transfer bench, Toilet rails, Bed side commode] in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG- Orientation',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The resident will communicate/verbalize mental awareness of [Orientation] given [Percent] [Verbal Cueing] in order to [Safety Outcomes] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG- Sequencing',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will communicate/verbalize mental awareness of [Orientation] given [Percent] [Verbal Cueing] to (ENTER FUNCTIONAL TASK/OUTCOME).',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG: Orientation (LT) Goal',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The patient communicates/verbalizes mental awareness of [Orientation] given [Percent] [Verbal Cueing] .',
    TargetGoalText: '',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG: Orientation (ST) Goal',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will communicate/verbalize mental awareness of [Orientation] given [Percent] [Verbal Cueing] to (ENTER FUNCTIONAL TASK/OUTCOME).',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG-External Comp',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The resident will demonstrate use of external compensatory strategies including [Compensatory] assistance given [Percent] [Verbal Cueing] increasing to only [Cog Severity Scale] impairment level [environment] in order to [Safety Outcomes] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG-Internal Comp',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The resident will demonstrate use of internal compensatory strategies given [Percent] [Verbal Cueing] increasing to only [Cog Severity Scale] level of impairment [environment] in order to [Safety Outcomes] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG-Memory',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will demonstrate functional problem solving and safety awareness for daily living tasks given [Percent] [Verbal Cueing] increasing to only [Cog Severity Scale] in order to [Safety Outcomes] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'COG-Problem Solving',
    LongTerm: '',
    ShortTerm: '',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will demonstrate functional problem solving and safety awareness for daily living tasks given [Percent] [Verbal Cueing] increasing to only [Cog Severity Scale] in order to [Safety Outcomes] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'Fall risk: (Fear of Falling) ABC scale LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client demonstrates severity of fear of falling and fall risk level evidenced by an Activities Based Confidence Scale score of [Activities-Specific Balance Confidence Scale] which [Impacts/Supports for CLOF goals] ability to safely engage in community mobility, ADLs, and IADLs without fear and with reduced risk of falls',
    TargetGoalText:
      'Client will demonstrate reduced fear of falling and reduced fall risk evidenced by an Activities Based Confidence scale score of [Activities-Specific Balance Confidence Scale] in order to engage in community mobility, ADLs, and IADLs with reduced fear and reduced risk of falls',
  },
  {
    Discipline: 'OT',
    GoalName: 'LTG -1 new',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client demonstrates (enter specific underlying impairment) as evidenced by (enter specific objective measure) which negatively impacts ability to (enter functional deficit).',
    TargetGoalText:
      'The client will demonstrate improved (enter specific deficit/impairment) as evidenced by (enter objective measure) in order to (enter functional performance).',
  },
  {
    Discipline: 'OT',
    GoalName: 'LTG -2 new',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client demonstrates (enter specific underlying impairment) as evidenced by (enter specific objective measure) which negatively impacts ability to (enter functional deficit).',
    TargetGoalText:
      'Client will demonstrate an improvement in balance as evidenced by an increased score in the Functional Reach test of [Functional Reach] in order to reduce fall risk and to facilitate [Functional Balance scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'LTG custom- 1',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved (ENTER underlying impairment or functional deficit) evidenced by (ENTER measure) in order to (ENTER life participation).',
  },
  {
    Discipline: 'OT',
    GoalName: 'Medication Management (LT) Goal',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Patient current requires [Level of Assistance] to manage medication dosage, frequency, and timing with medication planner or other assistive equipment.',
    TargetGoalText:
      'Patient will manage medication dosage, frequency, and timing with [Level of Assistance] with use of medication planner or other assistive equipment as needed.',
  },
  {
    Discipline: 'OT',
    GoalName: 'Medication Management (ST) Goal',
    LongTerm: 'Y',
    ShortTerm: 'Y',
    CurrentGoalText:
      'Patient current requires [Level of Assistance] to manage medication dosage, frequency, and timing with medication planner or other assistive equipment.',
    TargetGoalText:
      'Patient will manage medication dosage, frequency, and timing with [Level of Assistance] with use of medication planner or other assistive equipment as needed.',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Bathing LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] assistance for [Bathing Type] with (ENTER AE/DME: ie: No device, Long-handled sponge, Wash mitt, Shower chair, Tub transfer bench, Grab bar) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [Bathing Type] bathing as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/DME: ie: No device, Long-handled sponge, Wash mitt, Shower chair, Tub transfer bench, Grab bar) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Bathing LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] assistance for [Bathing Type] with (ENTER AE/DME: ie: No device, Long-handled sponge, Wash mitt, Shower chair, Tub transfer bench, Grab bar) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [Bathing Type] bathing as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/DME: ie: No device, Long-handled sponge, Wash mitt, Shower chair, Tub transfer bench, Grab bar) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Cardiopulmonary Performance LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: 'with normal vital sign response in order to',
    TargetGoalText:
      'Client will demonstrate improved cardiopulmonary performance evidenced by ability to engage in exercise at an intensity of\n [RPE scale 6-20] utilizing [RPE/HRR] with normal vital sign response in order to [ADL OT Participation Scale]',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Cueing LTG 1',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Resident will require cueing while participating in (ENTER functional activity ex. ADLs, dressing, medication management, etc) in order to .',
    TargetGoalText:
      'Resident will require [OT Cueing Amount] [OT Cuing Type] cueing while participating in (ENTER functional activity ex. ADLs, dressing, medication management, etc) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Cueing LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Resident will require cueing while participating in (ENTER functional activity ex. ADLs, dressing, medication management, etc) in order to .',
    TargetGoalText:
      'Resident will require [OT Cueing Amount] [OT Cuing Type] cueing while participating in (ENTER functional activity ex. ADLs, dressing, medication management, etc) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Dressing LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] for [Dressing Type] with (ENTER AE/DME: ie: No device, Reacher, Sock aide, Dressing Stick, Long handled shoe horn, LE lifter, Button hook, Zipper pull, Grab bars, Walker, Straight cane, Quad cane, commode) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [Dressing Type] dressing as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/DME: ie: No device, Reacher, Sock aide, Dressing Stick, Long handled shoe horn, LE lifter, Button hook, Zipper pull, Grab bars, Walker, Straight cane, Quad cane, commode) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Dressing LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] for [Dressing Type] with (ENTER AE/DME: ie: No device, Reacher, Sock aide, Dressing Stick, Long handled shoe horn, LE lifter, Button hook, Zipper pull, Grab bars, Walker, Straight cane, Quad cane, commode) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [Dressing Type] dressing as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/DME: ie: No device, Reacher, Sock aide, Dressing Stick, Long handled shoe horn, LE lifter, Button hook, Zipper pull, Grab bars, Walker, Straight cane, Quad cane, commode) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Grooming LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] for [Grooming] with (ENTER AE/device: ie: no device, long-handled comb, built-up toothbrush, universal cuff, weighted universal holder, suction-cup denture brush) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [OT Grooming Type] as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/device: ie: no device, long-handled comb, built-up toothbrush, universal cuff, weighted universal holder, suction-cup denture brush) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT IADL LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'as evidenced by with [ENTER Device/DME ex: rolling walker, rollator, pillbox, etc] in order to',
    TargetGoalText:
      'Resident will demonstrate improved ability to [IADL Type OT] as evidenced by [Level of Assistance] with [ENTER Device/DME ex: rolling walker, rollator, pillbox, etc] in order to [ADL OT Participation Scale]',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Orthotics/Prosthetics/Splinting Application LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'will demonstrate ability to appropriately donn/doff (ENTER type of orthosis/prosthesis/splint) to (ENTER location) as demonstrated by in order to(ENTER life participation area i.e. reduce edema, reduce pain, reduce risk for contracture, etc)',
    TargetGoalText:
      '[Resident/Caregiver] will demonstrate ability to appropriately donn/doff (ENTER type of orthosis/prosthesis/splint) to (ENTER location) as demonstrated by [Level of Assistance] in order to(ENTER life participation area i.e. reduce edema, reduce pain, reduce risk for contracture, etc)',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Orthotics/Prosthetics/Splinting Application LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'will demonstrate ability to appropriately donn/doff (ENTER type of orthosis/prosthesis/splint) to (ENTER location) as demonstrated by in order to(ENTER life participation area i.e. reduce edema, reduce pain, reduce risk for contracture, etc)',
    TargetGoalText:
      '[Resident/Caregiver] will demonstrate ability to appropriately donn/doff (ENTER type of orthosis/prosthesis/splint) to (ENTER location) as demonstrated by [Level of Assistance] in order to(ENTER life participation area i.e. reduce edema, reduce pain, reduce risk for contracture, etc)',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Orthotics/Prosthetics/Splinting Wearing Tolerance LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Resident will demonstrate ability to wear(ENTER orthotic/prosthetic/splint type/location) without adverse skin conditions in order to(ENTER life participation area i.e. reduce edema, reduce pain, maintain skin integrity, etc).',
    TargetGoalText:
      'Resident will demonstrate ability to wear(ENTER orthotic/prosthetic/splint type/location) [Splinting Time] without adverse skin conditions in order to(ENTER life participation area i.e. reduce edema, reduce pain, maintain skin integrity, etc).',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Orthotics/Prosthetics/Splinting Wearing Tolerance LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Resident will demonstrate ability to wear(ENTER orthotic/prosthetic/splint type/location) without adverse skin conditions in order to(ENTER life participation area i.e. reduce edema, reduce pain, maintain skin integrity, etc).',
    TargetGoalText:
      'Resident will demonstrate ability to wear(ENTER orthotic/prosthetic/splint type/location) [Splinting Time] without adverse skin conditions in order to(ENTER life participation area i.e. reduce edema, reduce pain, maintain skin integrity, etc).',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Pain LTG (1)',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Resident will demonstrate reduction of pain in (ENTER location of pain) as evidenced by a score of (ENTER Score/max score) on (ENTER scale name: VAS, PCS, PSEQ, Wong-Baker) in order to (ENTER life participation area: participate in ADLs/IADLs, perform community/leisure tasks, perform functional mobility, etc).',
    TargetGoalText:
      'Resident will demonstrate reduction of pain in (ENTER location of pain) as evidenced by a score of (ENTER Score/max score) on (ENTER scale name: VAS, PCS, PSEQ, Wong-Baker) in order to (ENTER life participation area: participate in ADLs/IADLs, perform community/leisure tasks, perform functional mobility, etc).',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Pain LTG (2)',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Resident will demonstrate reduction of pain in (ENTER location of pain) as evidenced by a score of (ENTER Score/max score) on (ENTER scale name: VAS, PCS, PSEQ, Wong-Baker) in order to (ENTER life participation area: participate in ADLs/IADLs, perform community/leisure tasks, perform functional mobility, etc).',
    TargetGoalText:
      'Resident will demonstrate reduction of pain in (ENTER location of pain) as evidenced by a score of (ENTER Score/max score) on (ENTER scale name: VAS, PCS, PSEQ, Wong-Baker) in order to (ENTER life participation area: participate in ADLs/IADLs, perform community/leisure tasks, perform functional mobility, etc).',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Self-Feeding LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'assistance for with (ENTER AE/device: ie: No device, Weighted utensils, Built-up utensils, Universal cuff, Plate guard, Divided plate, Scoop dish, Dycem, Spout Lid Cup, Nosey cup) in order to ability to .',
    TargetGoalText:
      'Resident will demonstrate improved [Self Feeding Type] as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/device: ie: No device, Weighted utensils, Built-up utensils, Universal cuff, Plate guard, Divided plate, Scoop dish, Dycem, Spout Lid Cup, Nosey cup) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Strength LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '(ENTER location tested) (OR ENTER: 5x sit<>stand score/dynamometer/pinch score and norms) in order to perform (ENTER functional task: ADLs/IADLs, transfers, recreational/leisure tasks).',
    TargetGoalText:
      'Resident will demonstrate improved (ENTER location tested) strength as evidenced by [Muscle Strength] (OR ENTER: 5x sit<>stand score/dynamometer/pinch score and norms) in order to perform (ENTER functional task: ADLs/IADLs, transfers, recreational/leisure tasks).',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Toileting LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] assistance for [Toileting Type] with (ENTER AE/DME: ie: No device, Grab bar, Toilet aide) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [Toileting Type] as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/DME: ie: No device, Grab bar, Toilet aide) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'OT Toileting LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      '[Assistance Level] assistance for [Toileting Type] with (ENTER AE/DME: ie: No device, Grab bar, Toilet aide) in order to [Impacts/Supports for CLOF goals] ability to [ADL OT Participation Scale] .',
    TargetGoalText:
      'Resident will demonstrate improved [Toileting Type] as evidenced by assistance needed of [Level of Assistance] with (ENTER AE/DME: ie: No device, Grab bar, Toilet aide) in order to [ADL OT Participation Scale] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'Transfers OT LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'Client will demonstrate improved [Transfer type] transfers evidenced by assistance needed of [Level of Assistance] with [Assistive Device] in order to [Transfer Life Participation OT] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'Transfers OT LTG 2',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will demonstrate decreased episodes of urinary leakage to [Increments] time(s)/day as a result of [UI TX] .',
  },
  {
    Discipline: 'OT',
    GoalName: 'Wheelchair Assessment: PIDA Global STG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client will demonstrate improved ability to manage powered mobility device as evidenced by (ENTER score)% score on PIDA in order to increase their ability to safely navigate in their apt./cottage room, complete ADL routine, and retrieve personal items.',
    TargetGoalText:
      'Client will demonstrate improved ability to manage powered mobility device as evidenced by (ENTER score)% score on PIDA in order to increase their ability to safely navigate in their apt./cottage room, complete ADL routine, and retrieve personal items.',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Ambulation - distance',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: 'The client ambulates',
    TargetGoalText:
      "The patient's distance walked will increase to [Increments 5] feet with [Assistive Device] safely, in order to [Ambulation Goal] within a [Increments] week period of time.",
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Ambulation LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'Client currently walks [Feet] , [Home Health Assistance] with [Assistive Device] and is unable to [Home Health - in order to] .',
    TargetGoalText:
      'Resident will demonstrate improved balance as evidenced by an increased score on the Berg Balance Scale of [Berg Balance Scale] in order to reduce fall risk and to facilitate [Functional Balance scale] safely.',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Balance - Berg LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: 'Client currently demonstrates a Berg balance score of [Berg Balance Scale] .',
    TargetGoalText:
      'Client will demonstrate an improvement in balance as evidenced by an increased score in the Functional Reach test of [Functional Reach] in order to reduce fall risk and to facilitate [Functional Balance scale] .',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Dynamic Balance',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: "The client's current dynamic balance is a grade of [Balance Grade] .",
    TargetGoalText:
      "The patient's dynamic balance will improve as evidenced by the ability to [Balance Goals] within a [Increments] week period of time.",
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Funct Potential',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'The patient will reach maximum functional potential by [Ambulation Goal] safely, in a [Increments] week period of time.',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Mobility',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The clients current mobility is limited to [Feet] with a [Assistive Device] and [Assistance Level] level of assistance.',
    TargetGoalText:
      'The patients long term mobility will improve as evidenced by [Distance Feet] within [Increments] period of time.\nperiod of time. \nWeeks period of time',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Mobility - balance',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: "The client's current balance is a grade [Balance Grade] .",
    TargetGoalText:
      'The patients mobility will improve as evidenced by [Balance Goals] within a [Increments] week period of time',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Mobility distance',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'The patients long term mobility will improve as evidenced by the distance increased to [Distance Feet] within a [Increments] week period of time.',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Muscle strength',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: '',
    TargetGoalText:
      'The patients muscle strength will improve as evidenced by an increase in grade to [Muscle Strength] within a [Increments] week period of time',
  },
  {
    Discipline: 'ST',
    GoalName: 'LTG - 3 new',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client demonstrates (enter specific underlying impairment) as evidenced by (enter specific objective measure) which negatively impacts ability to (enter functional deficit).',
    TargetGoalText:
      'The client will demonstrate improved (enter specific deficit/impairment) as evidenced by (enter objective measure) in order to (enter functional performance).',
  },
  {
    Discipline: 'ST',
    GoalName: 'HH - Balance - Reach LTG',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText: "Client's current score on the Functional Reach test is [Functional Reach] .",
    TargetGoalText:
      'Client will demonstrate an improvement in balance as evidenced by an increased score in the Functional Reach test of [Functional Reach] in order to reduce fall risk and to facilitate [Functional Balance scale] .',
  },
  {
    Discipline: 'ST',
    GoalName: 'LTG - 3 new',
    LongTerm: 'Y',
    ShortTerm: 'N',
    CurrentGoalText:
      'The client demonstrates (enter specific underlying impairment) as evidenced by (enter specific objective measure) which negatively impacts ability to (enter functional deficit).',
    TargetGoalText:
      'The client will demonstrate improved (enter specific deficit/impairment) as evidenced by (enter objective measure) in order to (enter functional performance).',
  },
];

export default function findGoals(searchString: string) {
  if (searchString.length < 3) {
    return [];
  }
  const searchTerms = searchString.split(' ');
  const results = goal_list.filter((goal) => {
    return searchTerms.every((term) => {
      return (
        goal.GoalName.toLowerCase().includes(term.toLowerCase()) ||
        goal.CurrentGoalText.toLowerCase().includes(term.toLowerCase()) ||
        goal.TargetGoalText.toLowerCase().includes(term.toLowerCase())
      );
    });
  });
  return results.slice(0, 5);
}
